import styled from 'styled-components';

const Visualization = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export default Visualization;
